import React from 'react';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import CancelIcon from '@mui/icons-material/Cancel';

const styles = {
  chip: {
    m: 1,
    fontSize: '14px',
    background: 'rgba(0, 117, 169, 0.2)',
    maxWidth: '250px',
    textOverflow: 'ellipsis',
    border: 1,
    borderColor: '#4e6b7c',
  },
  icon: {
    border: '1px solid transparent',
    '&:hover': { border: 1, borderColor: 'secondary' },
    transition: 'border-color 0.3s ease-in-out',
  },
};

const SelectedFilters = props => {
  const { selectedFilters, handleFilterRemove } = props;

  return (
    <Box my={5} border="2px solid #E0E0E0" borderRadius="4px">
      <Stack direction="row" justifyContent="space-between" alignItems="center" mx={2} mt={1}>
        <Box fontSize="17px" color="#4e6b7c" fontWeight={700}>
          Selected Filters:
        </Box>
        <IconButton disableRipple sx={styles.icon} onClick={handleFilterRemove}>
          <CancelIcon color="secondary" />
        </IconButton>
      </Stack>
      <Box flexWrap="wrap" mx={1}>
        {selectedFilters?.map(filter => (
          <Tooltip
            key={filter}
            title={filter}
            placement="top-end"
            slotProps={{
              popper: {
                sx: {
                  zIndex: 20000,
                },
              },
            }}
            disableHoverListener={filter?.length < 30}
          >
            <Chip sx={styles.chip} label={filter} />
          </Tooltip>
        ))}
      </Box>
    </Box>
  );
};
export default SelectedFilters;
